/* eslint-disable */
import {financialYear} from '../interface/Units';
import useCompanyStore from '../store/companyStore/companyDetailsStore';
import RegEx from '../utils/FormUtils/RegEx';

const {AprMar, JanDec, JulJun, OctSep} = financialYear;
// sub_category_changes
export const processTypeShow = [4, 5, 50, 75, 76, 77, 78, 79, 83];

export const processTypeFilter = () => {
  const {companyDetails} = useCompanyStore.getState();
  return processTypeShow.includes(companyDetails.subCategory);
};

export const drawerZIndex = 1200;

export const months = {
  [AprMar]: [
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
    'Jan',
    'Feb',
    'Mar'
  ],
  [JanDec]: [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
  ],
  [JulJun]: [
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun'
  ],
  [OctSep]: [
    'Oct',
    'Nov',
    'Dec',
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep'
  ]
};

export const getMonthsRange = (str: financialYear, useFullNames = false) => {
  const shortMonths = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
  ];

  const fullMonths = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
  ];

  const months = useFullNames ? fullMonths : shortMonths;

  const startMonth = str.slice(0, 3);
  const endMonth = str.slice(3, 6);

  // For full names, map short month to full month index:
  const startIndex = shortMonths.indexOf(startMonth);
  const endIndex = shortMonths.indexOf(endMonth);

  if (startIndex === -1 || endIndex === -1) {
    throw new Error('Invalid month abbreviation');
  }

  let result = [];
  if (startIndex <= endIndex) {
    result = months.slice(startIndex, endIndex + 1);
  } else {
    result = months.slice(startIndex).concat(months.slice(0, endIndex + 1));
  }

  return result;
};

export const monthsInFull = {
  [AprMar]: [
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
    'January',
    'February',
    'March'
  ],
  [JanDec]: [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
  ],
  [JulJun]: [
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
    'January',
    'February',
    'March',
    'April',
    'May',
    'June'
  ],
  [OctSep]: [
    'October',
    'November',
    'December',
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September'
  ]
};

export const CommonErrors = {
  nonDecimalNonNegative: 'Please provide a value more than 0 and non decimal.',
  percentageError: 'Percentage should be between 0.01 to 100.00',
  twoDigitPositive: 'Value should be more than 0 and upto two decimal places ',
  twoDigitDecimalMoreThanZero:
    'Please enter value more than 0 and upto two decimal places',
  mandatory: (label: string): string => {
    return `${label} is Mandatory`;
  },
  threeDigitDecimalMoreThanZero:
    'Please enter value more than 0 and upto three decimal places',

  selectAgain: 'Please select this field again',
  noSpecialChar: 'No Special character or numbers are allowed',
  noAllowedSpecChar: "No special characters are allowed Excluding &',.() -",
  validField: (label: string): string => {
    return `Please enter a valid ${label}`;
  },
  validDigitField: (
    label: string,
    limit: number,
    isNumberText: boolean = false
  ): string => {
    return `Please enter a valid ${limit} digit ${label} ${
      isNumberText ? 'Number' : ''
    }`;
  },
  notMoreThan: (label: string, limit: number): string => {
    return `${label} Should not be more than ${limit} Characters`;
  },
  notLessThan: (label: string, limit: number): string => {
    return `${label} Should be more than ${limit} ${
      limit === 1 ? `Character` : 'Characters'
    } `;
  },
  duplicatesFound: (label: string): string => {
    return `Duplicate ${label} found in the entered records`;
  },
  alreadyExistsFound: (label: string): string => {
    return `${label} already exists`;
  }
};

export const noData = {
  firstSelect: (label: string): string => {
    return `Please select ${label} first`;
  },
  noTableData: (): string => {
    return 'No data found';
  }
};

export const transformInput = {
  removeExtraSpace: (s: string): string => s.replace(RegEx.transformInput, ' ')
};

export const detectAutoDetect = (): string => {
  if (navigator.userAgent.includes('Chrome')) {
    return 'new-password';
  } else {
    return 'off';
  }
};

export const TF = 'timeFrameData';

export const GenerateReportButtonText = (
  isGenerating: boolean = false
): string => {
  return isGenerating ? 'Generating...' : 'Generate Report';
};

export const handleFalsyValues = (data: any[]): any[] => {
  return data.map((item) => {
    const {value} = item;
    const normalizedValue =
      value === null ||
      value === undefined ||
      value === '' ||
      value === 'NA' ||
      typeof value !== 'number'
        ? 0
        : value;

    return {
      ...item,
      value: normalizedValue
    };
  });
};
